import packageJson from '@root/package.json';

export const VERSION_INFO = {
  appVersion: packageJson.version,
  buildVersion: packageJson.buildNumber,
  appName: packageJson.name
} as const;
